// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import Search from "@werner/XDL/Icons/Search";
import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        placeholder: "",
        mergeCss: true,
        iconProps: {
            src: Search,
            size: 16,
            color: "primary.main",
            css: css`
                z-index: 2;
            `,
        },
        cssOverrides: {
            selectedText: css`
                text-align: left;
                padding: ${({ _sizeVariant }: any) =>
                    _sizeVariant === "small" ? "5px 24px 5px 11px" : "28px 24px 9px 11px"};
            `,
            // XNG-Changes
            list: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
